import { css, html } from "../helpers/webComponents";
import { CanvasComponent } from "./CanvasComponent";

/**
 * Represents the intro screen.
 */
export class IntroComponent extends CanvasComponent {
    /**
     * @inheritdoc
     */
    protected styles(): string {
        return css`
            :host {
                --background-color: rgba(1, 1, 1, 0.7);
                --padding: 20px;
                --margin: 50px;
                --border-radius: 10px;
                --blur: 10px;
            }

            .title {
                background-color: var(--background-color);
                padding: var(--padding);
                overflow: unset;
                width: 100%;
                margin-top: var(--margin);
                box-sizing: border-box;
                backdrop-filter: blur(var(--blur));
                border-radius: var(--border-radius);
                box-shadow: var(--box-shadow);
            }

            .title h1 {
                margin: 0;
            }

            .buttons {
                display: flex;
            }

            .wrapper {
                align-items: center;
                gap: var(--margin);
            }

            .content {
                height: 100%;
                background-color: var(--background-color);
                backdrop-filter: blur(var(--blur));
                border-radius: var(--border-radius);
                padding: 20px;
                box-shadow: var(--box-shadow);
            }

            .footer {
                background: 0;
                padding: 0;
            }

            .footer .button {
                width: max-content;
                background-color: var(--background-color);
                padding: var(--padding);
                margin: 0;
                backdrop-filter: blur(var(--blur));
                border-radius: var(--border-radius);
                box-shadow: var(--box-shadow);
            }

            .footer .button:hover {
                background-color: rgba(1, 1, 1, 1);
            }

            .main {
                display: flex;
                align-items: flex-end;
                height: 100%;
                width: 100%;
                margin-bottom: var(--margin);
            }
        `;
    }

    /**
     * @inheritdoc
     */
    protected renderBody(): HTMLElement {
        return html`
            <div class="wrapper">
                ${this.renderTitle()}

                <div class="main">
                    ${this.renderContent()}
                    ${this.renderFooter()}
                </div>
            </div>
        `;
    }

    /**
     * @inheritdoc
     */
    protected renderTitle(): string {
        const roomName: string | undefined = this._currentGameState?.roomName;

        return `
            <div class="title">
                <h1>${roomName}</h1>
            </div>
        `;
    }

    /**
     * @inheritdoc
     */
    protected renderContent(): string {
        return `
            <div class="content">
                ${this.renderContentText()}
            </div>
        `;
    }

    /**
     * @inheritdoc
     */
    protected renderFooter(): HTMLElement {
        return html`
            <div class="footer">
                ${this._currentGameState?.actions.map(button => this.renderActionButton(button))}
            </div>
        `;
    }
};
